module.exports = __webpack_public_path__ + "assets/close-popup-e4c786.svg";